import { render, staticRenderFns } from "./background-image.vue?vue&type=template&id=6ad31b5a&scoped=true&"
import script from "./background-image.vue?vue&type=script&lang=js&"
export * from "./background-image.vue?vue&type=script&lang=js&"
import style0 from "./background-image.vue?vue&type=style&index=0&id=6ad31b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad31b5a",
  null
  
)

export default component.exports